import {
  REQUEST_DATA,
  RECEIVE_DATA,
  REQUEST_LANDING,
  RECEIVE_LANDING,
  REQUEST_INDICATOR_META,
  RECEIVE_INDICATOR_META,
  RESET_DATA,
  UPDATE_DATA,
  UPDATE_FILTER,
  RESET_FILTER,
  TOGGLE_FILTER,
  SET_UI_FLAG,
} from 'config/types';

export default function actionTrigger(type, data) {
  return { type, payload: data };
}

export function actionRequestData(key) {
  return actionTrigger(REQUEST_DATA, { key });
}

export function actionReceiveData(key, data = {}) {
  return actionTrigger(RECEIVE_DATA, { key, data });
}

export function actionRequestLanding(key) {
  return actionTrigger(REQUEST_LANDING, { key });
}

export function actionReceiveLanding(key, data = {}) {
  return actionTrigger(RECEIVE_LANDING, { key, data });
}

export function actionRequestIndicatorMeta(key) {
  return actionTrigger(REQUEST_INDICATOR_META, { key });
}

export function actionReceiveIndicatorMeta(key, data = {}) {
  return actionTrigger(RECEIVE_INDICATOR_META, { key, data });
}

export function actionResetData() {
  return actionTrigger(RESET_DATA);
}

export function actionUpdateData(key, data = {}) {
  return actionTrigger(UPDATE_DATA, { key, data });
}

export function actionUpdateFilter(geos = [], add = false) {
  return actionTrigger(UPDATE_FILTER, { geos, add });
}

export function actionResetFilter() {
  return actionTrigger(RESET_FILTER);
}

export function actionToggleFilter() {
  return actionTrigger(TOGGLE_FILTER);
}

export function actionSetUIFlag() {
  return actionTrigger(SET_UI_FLAG);
}



// WEBPACK FOOTER //
// ./app/actions/index.js